import type { SVGProps } from 'react';

export const FaceHappy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="512px"
    role="img"
    viewBox="0 0 512 512"
    width="512px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'face happy'}</title>
    <g transform="scale(1,-1) translate(0 -512)">
      <path
        d="M256 479c124 0 223-100 223-223 0-124-100-223-223-223-124 0-223 99-223 223 0 124 99 223 223 223m0 33c-141 0-256-115-256-256 0-141 115-256 256-256 141 0 256 115 256 256 0 141-115 256-256 256m0-413c42 0 82 22 106 56 2 4 2 10-2 11-3 2-9 2-11-1-20-32-55-50-93-50-40 0-77 22-97 55-2 4-7 6-11 4-4-2-5-8-4-11 24-40 66-64 112-64m-55 150c2 0 4 0 6 2 3 1 3 7 1 10l-38 50c-2 2-4 4-5 4-2 0-6-2-6-4l-38-44c-4-4-2-9 2-11 1-4 5-4 9 0l31 37 33-42c1-2 3-2 5-2m104 0c2 0 6 2 6 3l33 42 31-36c4-4 7-4 11-2 3 4 3 7 2 11l-37 44c-2 2-4 4-5 4-2 0-6-2-6-4l-38-50c-2-3-2-9 2-10 0-2 1-2 1-2"
        fill={props.fill}
      />
    </g>
  </svg>
);
